// extracted by mini-css-extract-plugin
export default {"timeToDestination":"JourneyView_timeToDestination__z2evD","routeStepSlider":"JourneyView_routeStepSlider__uPqQN","interceptSummary":"JourneyView_interceptSummary__sG0NU"};